// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React, { useState } from 'react'
import xsLMBannerImg from 'images/CC-HPbanner_licmgt-768x300.jpg'
import smLMBannerImg from 'images/CC-HPbanner_licmgt-992x144.jpg'
import mdLMBannerImg from 'images/CC-HPbanner_licmgt-1512x144.jpg'
import lgLMBannerImg from 'images/CC-HPbanner_licmgt-1989x192.jpg'

import {
  Carousel,
  CarouselItem,
} from 'reactstrap'

const Banner = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [animating, setAnimating] = useState(false)

  const items = [
    <a key={lgLMBannerImg}
      className={'display-block'}
      href={'https://www.comsearch.com/services/6-ghz/3-step-process/'}
      rel={'noopener noreferrer'}
      target={'_blank'}>
      <picture>
        <source media={'(max-width: 767px)'} srcSet={xsLMBannerImg} />
        <source media={'(min-width: 768px) and (max-width: 991px)'} srcSet={smLMBannerImg} />
        <source media={'(min-width: 992px) and (max-width: 1199px)'} srcSet={mdLMBannerImg} />
        <img
          alt={'CONNECT BANNER'}
          className={'img-fluid'}
          src={lgLMBannerImg}
          style={{ width: '100%' }} />
      </picture>
    </a>,
  ]

  const next = () => {
    if (animating) return
    const nextIndex = (activeIndex + 1) % items.length
    setActiveIndex(nextIndex)
  }

  const previous = () => {
    if (animating) return
    const nextIndex = activeIndex ? activeIndex - 1 : items.length - 1
    setActiveIndex(nextIndex)
  }

  return (
    <Carousel
      className={'d-none d-sm-block'}
      activeIndex={activeIndex}
      next={next}
      previous={previous}
      interval={7000} >
      {(
        items.map((item, i) => (
          <CarouselItem
            key={i}
            onExiting={() => setAnimating(true)}
            onExited={() => setAnimating(false)} >
            { item }
          </CarouselItem>
        ))
      )}
    </Carousel>
  )
}

export default Banner
